import { useEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import { Platform } from 'react-native'
import { verify_user_cognito, isAuthCooldownActive } from '../../../utils/functions.utils'

export const useVerifyCognito = () => {
    const [reloadCounter, setReloadCounter] = useState(0)
    let navigation: any = null
    try {
        navigation = useNavigation()
    } catch (e) {
        if (Platform.OS === 'web') {
            navigation = { addListener: () => () => {} }
        } else {
            throw e
        }
    }

    useEffect(() => {
        if (navigation && navigation.addListener) {
            const unsubscribe = navigation.addListener('focus', () => {
                setReloadCounter((prevCounter) => prevCounter + 1)
            })
            return unsubscribe
        }
        return () => {}
    }, [navigation])

    useEffect(() => {
        if (isAuthCooldownActive()) return
        verify_user_cognito()
    }, [reloadCounter])

    return {}
}
